export default __webpack_public_path__ + "static/media/Club.71fe16b6.jpg";